import React from "react"
import ShareButtons from "./shared/shareButtons/ShareButtons"
import BlogPreviewWrapper from "./shared/blogPreviewWrapper/BlogPreviewWrapper"
import BlogPreviewContent from "./shared/blogPreviewContent/BlogPreviewContent"
import BlogPreviewTitle from "./shared/blogPreviewTitle/BlogPreviewTitle"
import BlogPreviewImage from "./shared/blogPreviewImage/BlogPreviewImage"
import BlogPreviewConfirmedDoctor from "./shared/blogPreviewConfirmedDoctor/BlogPreviewConfirmedDoctor"
import BlogPreviewDescription from "./shared/blogPreviewDescription/BlogPreviewDescription"
import BlogPreviewAuthor from "./shared/blogPreviewAuthor/BlogPreviewAuthor"
import BlogPreviewForm from "./shared/blogPreviewForm/BlogPreviewForm"
import ResponseModal from "../../../blogList/components/shared/blogListForm/components/ResponseModal/ResponseModal"
import BlogList from "../../../blogList/components/BlogList"
import BlogListContent from "../../../blogList/components/shared/blogListContent/BlogListContent"
import BlogListWrapper from "../../../blogList/components/shared/blogListWrapper/BlogListWrapper"
import { Link } from "gatsby"
import ArticleType from "./shared/articleType/ArticleType"
import axios from "axios"
import CalculatorsPostsLinks from "./shared/calculatorsPostsLinks/CalculatorsPostsLinks"
import LocaleContext from "../../../../../context/LocaleContext"

class BlogPreview extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      responseModal: false,
      error: "",
      path: "path",
      embeddedAssetModal: false,
      embeddedImage: null,
      loading: false,
      subdomain: "bg",
      preferredLang: "bg-BG",
      errors: {},
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
  }

  updateWindowDimensions = () => {
    let path = window.location.pathname.slice(1)
    let place = path.search("/", path)
    let result =
      path === "" ? "/" : window.location.pathname.slice(0, place + 600)
    this.setState({ path: result })
  }

  toggleEmbeddedAssetModal = image => {
    this.setState({
      embeddedAssetModal: !this.state.embeddedAssetModal,
      embeddedImage: image,
    })
  }

  handleEmailChange = event => {
    this.setState({ email: event.target.value })
  }
  handleCloseModal = () => {
    this.setState({ responseModal: false, error: "" })
  }

  validate = () => {
    const { email } = this.state
    let newErrors = {}
    if (email !== "undefined") {
      let pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      )
      if (!pattern.test(email)) {
        newErrors.email = "Моля въведете валиден емайл адрес"
      }
    }
    this.setState({ errors: newErrors })
    return !Object.keys(newErrors).length
  }

  handleSubmit = e => {
    e.preventDefault()
    const { email } = this.state
    let isValid = this.validate()
    if (isValid) {
      this.setState({ loading: true })
      axios
        .post(
          "https://cors-anywhere.herokuapp.com/https://api.dianurse.com/dianurse/v1/newsletter/subscriber/add",
          {
            email,
            subdomain: this.state.subdomain,
            preferredLang: this.state.preferredLang,
          }
        )
        .then(result => {
          console.log(result)
          this.setState({
            error: result.data,
            responseModal: true,
            loading: false,
          })
        })
    }
    this.setState({ email: "" })
  }

  shuffle = a => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[a[i], a[j]] = [a[j], a[i]]
    }
    return a
  }

  render() {
    const { embeddedAssetModal, embeddedImage, loading, errors } = this.state
    const {
      blogs,
      allBlogs,
      pageTitle,
      microDataDescription,
      favicon,
    } = this.props

    const { locale } = this.context

    let uniqueResultOne = allBlogs.filter(function (obj) {
      return !blogs.some(function (obj2) {
        return obj.node.id === obj2.node.id
      })
    })

    let uniqueResultTwo = blogs.filter(function (obj) {
      return !allBlogs.some(function (obj2) {
        return obj.node.id === obj2.node.id
      })
    })

    let result = uniqueResultOne.concat(uniqueResultTwo)
    let shuffledResult = this.shuffle(result)

    return (
      <React.Fragment>
        <BlogPreviewWrapper>
          <ShareButtons slug={blogs[0].node.slug} />
          {blogs ? (
            <BlogPreviewContent>
              {blogs.map(blog => (
                <div key={blog.node.id}>
                  <BlogPreviewTitle title={blog.node.title} />
                  <BlogPreviewConfirmedDoctor
                    author={blog.node.author}
                    doctor={blog.node.confirmedBy}
                    timeToRead={blog.node.timeToRead}
                    date={blog.node.date}
                  />
                  <BlogPreviewImage
                    largeImage={
                      blog.node.largeImage && blog.node.largeImage.fluid
                    }
                    title={blog.node.title}
                    image={blog.node.mainImage.fluid}
                  />
                  <ArticleType
                    favicon={favicon}
                    microDataDescription={microDataDescription}
                    pageTitle={pageTitle}
                    post={blog.node}
                  />

                  <BlogPreviewDescription
                    embeddedImage={embeddedImage}
                    embeddedAssetModal={embeddedAssetModal}
                    toggleEmbeddedAssetModal={this.toggleEmbeddedAssetModal}
                    description={blog.node.content.json}
                  />

                  {blog.node.tags && (
                    <div className="blog-tags-holder">
                      <p>Тагове:</p>
                      {blog.node.tags &&
                        blog.node.tags.map((tag, index) => {
                          return (
                            <Link key={index} to={`/${tag.tagName}/`}>
                              {tag.tagName}
                            </Link>
                          )
                        })}
                    </div>
                  )}
                  {blog.node.internalLink && (
                    <CalculatorsPostsLinks
                      internalLink={blog.node.internalLink}
                    />
                  )}
                  <BlogPreviewAuthor
                    author={blog.node.author}
                    authorName={blog.node.author && blog.node.author.name}
                    authorEmail={blog.node.author.email}
                  />
                </div>
              ))}

              {this.state.responseModal === false ? (
                ""
              ) : (
                <ResponseModal
                  responseModal={this.state.responseModal}
                  closeModal={this.handleCloseModal}
                  error={this.state.error}
                />
              )}

              <BlogPreviewForm
                locale={locale}
                loading={loading}
                errors={errors}
                path={this.state.path}
                email={this.state.email}
                handleChange={this.handleEmailChange}
                handleSubmit={this.handleSubmit}
              />
            </BlogPreviewContent>
          ) : (
            ""
          )}
        </BlogPreviewWrapper>
        <BlogListWrapper>
          <h2 className="more-posts-title">Други публикации</h2>
          <BlogListContent>
            {shuffledResult.slice(0, 3).map((blog, index) => {
              return <BlogList blog={blog.node} key={index} />
            })}
          </BlogListContent>
        </BlogListWrapper>
      </React.Fragment>
    )
  }
}

BlogPreview.contextType = LocaleContext

export default BlogPreview
